<template>
  <span class="netvs-icon-wrapper" :class="fade||beat_fade?'fade':''">
  <svg
    class="netvs-icon"
    :style="{width: px, height: px}"
    viewBox="0 0 24 24"
    role="img" aria-hidden="true"
    focusable="false">
    <path :d="resolve(icon)" fill="currentColor" />
  </svg>
  </span>
</template>

<script>
import {
  mdiAccessPointNetwork, mdiAccount, mdiAccountArrowLeftOutline,
  mdiAccountArrowRightOutline, mdiAccountCog, mdiAccountGroup,
  mdiAccountGroupOutline, mdiAccountLockOutline, mdiAccountMultipleOutline,
  mdiAccountPlus, mdiAccountSupervisorOutline, mdiAlert, mdiAlertOutline,
  mdiApi, mdiArrowCollapseDown, mdiArrowCollapseLeft, mdiArrowCollapseRight,
  mdiArrowCollapseUp, mdiArrowExpandLeft, mdiArrowExpandRight, mdiArrowRight,
  mdiAutoFix, mdiBackspaceOutline, mdiBackupRestore, mdiBellOutline, mdiBug,
  mdiBugOutline, mdiBullseyeArrow, mdiCableData, mdiCardAccountDetailsOutline,
  mdiChatOutline, mdiCheck, mdiCheckCircle, mdiCheckCircleOutline,
  mdiCheckDecagramOutline, mdiChevronDown, mdiChevronLeft, mdiClose,
  mdiCloseCircleOutline, mdiCodeBraces, mdiCodeJson, mdiCog, mdiContentCopy,
  mdiCreation, mdiCrownOutline, mdiDns, mdiDoorOpen, mdiEmailCheckOutline,
  mdiEmailOutline, mdiEmoticonHappyOutline,
  mdiEthernet, mdiEyeOffOutline, mdiEyeOutline, mdiFactory,
  mdiFileExportOutline, mdiFileImportOutline, mdiFileTreeOutline,
  mdiFilterOutline, mdiFire, mdiFormatListBulleted,
  mdiFormatListChecks, mdiFormatListNumbered, mdiFullscreen,
  mdiFullscreenExit, mdiGraphOutline, mdiHelp, mdiHelpCircleOutline,
  mdiHistory, mdiHome, mdiHomeCityOutline, mdiHomeMapMarker, mdiIncognito,
  mdiInformationOutline, mdiKeyVariant, mdiLan, mdiLanConnect,
  mdiLanDisconnect, mdiLayersOutline, mdiLifebuoy, mdiLink, mdiLinkOff,
  mdiLockCheck, mdiLoginVariant, mdiLogoutVariant, mdiMagnify, mdiMagnifyScan,
  mdiMapMarker, mdiMenu, mdiMenuDown, mdiMenuUp, mdiOfficeBuilding,
  mdiOfficeBuildingOutline, mdiOpenInNew, mdiOpenid, mdiOrbitVariant,
  mdiPlaylistRemove, mdiPlus, mdiPlusBoxOutline, mdiPower, mdiPowerSocket,
  mdiRadioactive, mdiRedo, mdiRestart, mdiRobotOutline, mdiRocketLaunch,
  mdiRocketOutline, mdiScriptTextOutline, mdiSearchWeb, mdiSend, mdiServer,
  mdiServerNetwork, mdiShieldHalfFull, mdiSitemap, mdiSkullOutline,
  mdiSquareEditOutline, mdiStarShooting, mdiTestTube, mdiTextBoxOutline,
  mdiToilet, mdiToolboxOutline, mdiTranslate, mdiTrashCanOutline, mdiUndo,
  mdiVectorSquareEdit, mdiViewGridOutline, mdiWeb, mdiWallFire, mdiUfoOutline, mdiReload, mdiAlertCircleOutline
} from '@mdi/js'

export default {
  name: 'netvs-icon',
  data() {
    return {
      map: {
        offline: mdiLanDisconnect,
        home: mdiHome,
        dnsvs: mdiDns,
        record: mdiTextBoxOutline,
        fqdn: mdiWeb,
        macauth: mdiLockCheck,
        bcd_seclvl: mdiShieldHalfFull,
        bcd_categ: mdiLayersOutline,
        dhcp_leases: mdiFormatListNumbered,
        natvs: mdiWallFire,
        netdoc: mdiSitemap,
        orgs: mdiOfficeBuilding,
        org_types: mdiOfficeBuildingOutline,
        macfinder: mdiMagnifyScan,
        groups: mdiAccountGroup,
        macvendor_search: mdiFactory,
        ap_list: mdiAccessPointNetwork,
        requests: mdiScriptTextOutline,
        copy: mdiContentCopy,
        collapse: mdiChevronDown,
        delete: mdiTrashCanOutline,
        create: mdiPlus,
        export: mdiFileExportOutline,
        import: mdiFileImportOutline,
        edit: mdiSquareEditOutline,
        search: mdiMagnify,
        evlog: mdiHistory,
        filter: mdiFilterOutline,
        execute: mdiSend,
        move_up: mdiMenuUp,
        move_down: mdiMenuDown,
        settings: mdiCog,
        devel_warning: mdiFire,
        test: mdiTestTube,
        prod: mdiCheckDecagramOutline,
        help: mdiHelpCircleOutline,
        unknown: mdiHelp,
        navigate: mdiArrowRight,
        language: mdiTranslate,
        link: mdiLink,
        vlan: mdiEthernet,
        vni: mdiLanConnect,
        cntl: mdiAccountCog,
        transaction_list: mdiFormatListChecks,
        delete_transaction_list: mdiPlaylistRemove,
        delete_transaction_element: mdiBackspaceOutline,
        clear: mdiClose,
        token: mdiKeyVariant,
        subgroups: mdiAccountSupervisorOutline,
        subaccounts: mdiAccountMultipleOutline,
        unlink: mdiLinkOff,
        bcd: mdiLan,
        group_members: mdiAccountGroupOutline,
        info: mdiInformationOutline,
        mail: mdiEmailOutline,
        undo: mdiUndo,
        redo: mdiRedo,
        expert_feature: mdiCrownOutline,
        sign_in: mdiLoginVariant,
        sign_in_oidc: mdiOpenid,
        sign_out: mdiLogoutVariant,
        documentation_help: mdiLifebuoy,
        api: mdiApi,
        bug: mdiBug,
        developer_feature: mdiBugOutline,
        development_feature: mdiCodeBraces,
        mobile_menu_sandwich: mdiMenu,
        user: mdiAccount,
        user_ninja: mdiIncognito,
        sidebar_collapse_to_left: mdiArrowCollapseLeft,
        sidebar_expand_to_left: mdiArrowExpandLeft,
        sidebar_collapse_to_right: mdiArrowCollapseRight,
        sidebar_expand_to_right: mdiArrowExpandRight,
        transaction_error: mdiAlert,
        transaction_success: mdiCheckCircle,
        request_sent: mdiEmailCheckOutline,
        netvs_fatal_error: mdiAlertCircleOutline,
        update_new_version: mdiReload,
        launchpad: mdiRocketOutline,
        launchpad_active: mdiRocketLaunch,
        launchpad_planet: mdiOrbitVariant,
        navigation_list_marker: mdiChevronLeft,
        power: mdiPower,
        monitoring_up: mdiCheckCircleOutline,
        monitoring_down: mdiCloseCircleOutline,
        refire_job: mdiRestart,
        warning: mdiAlertOutline,
        external_hazard: mdiRadioactive,
        transaction_returning: mdiBackupRestore,
        community_content: mdiStarShooting,
        garbage_collector: mdiToilet,
        alerts: mdiBellOutline,
        all_good: mdiEmoticonHappyOutline,
        add_item: mdiPlusBoxOutline,
        ip_tools: mdiToolboxOutline,
        eye_slash: mdiEyeOffOutline,
        eye: mdiEyeOutline,
        transaction_bundle: mdiCreation,
        transaction_additional: mdiAutoFix,
        transaction_api_object: mdiCodeJson,
        close: mdiClose,
        depersonate: mdiAccountArrowLeftOutline,
        impersonate: mdiAccountArrowRightOutline,
        svc_account: mdiRobotOutline,
        user_locked: mdiAccountLockOutline,
        check: mdiCheck,
        external_link: mdiOpenInNew,
        grid: mdiViewGridOutline,
        list: mdiFormatListBulleted,
        list_tree: mdiFileTreeOutline,
        arrow_down_from_line: mdiArrowCollapseDown,
        arrow_up_from_line: mdiArrowCollapseUp,
        ip_contact: mdiCardAccountDetailsOutline,
        domain_finder: mdiSearchWeb,
        graph: mdiGraphOutline,
        building: mdiHomeCityOutline,
        room: mdiDoorOpen,
        active_module: mdiServerNetwork,
        device: mdiServer,
        dd_module: mdiPowerSocket,
        target_module: mdiBullseyeArrow,
        chat: mdiChatOutline,
        maximize: mdiFullscreen,
        minimize: mdiFullscreenExit,
        geo_address: mdiHomeMapMarker,
        geo_marker: mdiMapMarker,
        defective: mdiSkullOutline,
        wire: mdiCableData,
        group_join: mdiAccountPlus,
        edit_api: mdiVectorSquareEdit,
      }
    }
  },
  computed: {
    px () {
      if (this.size == null) {
        return '1em'
      }
      switch (this.size) {
        case 'xs':
          return '0.75em'
        case 'sm':
          return '0.875em'
        case 'lg':
          return '1.33em'
        default:
          break
      }
      if (this.size.endsWith('x')) {
        return `${this.size.slice(0, -1)}em`
      }
      return this.size
    },
  },
  methods:
    {
      resolve(name) {
        if (name in this.map) {
          return this.map[name]
        }
        return mdiUfoOutline
      },
      click(e) {
        this.$emit('click', e)
      }
    },
  props: {
    size: {
      type: String,
      default() {
        return '1x'
      }
    },
    icon: {
      required: true,
      default() {
        return mdiUfoOutline
      }
    },
    beat_fade: {
      required: false,
      default() {
        return false
      }
    },
    fade: {
      required: false,
      default() {
        return false
      }
    }
  }
}
</script>

<style scoped>
.netvs-icon-wrapper {
  display: inline-block;
}

.netvs-icon {
  vertical-align: -0.125em;
}

@keyframes fade {
  0%, 100% { opacity: 0.4; }
  50%      { opacity: 1;   }
}

.fade {
  animation: fade 1s ease-in-out infinite;
}

</style>
